import { render } from "./AddItem.vue?vue&type=template&id=d25a1568&scoped=true"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"

import "./AddItem.vue?vue&type=style&index=0&id=d25a1568&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25a1568"]])

export default __exports__